import { AxiosResponse } from 'axios';
import { useAuth } from 'core/contexts';
import {
    withHeaders,
    instance as axiosInstance,
} from 'core/util/axiosInstance';
import { getDefaultHeaders } from 'core/util/other';
import { useQuery, UseQueryResult } from 'react-query';
import { Dictionary } from 'lib/types/dictionary-types';

const dictionaryBaseUrl = '/metadata/dictionary';

const fetchDictionary = async (
    url: string,
    token: string
): Promise<AxiosResponse<Dictionary, any>> => {
    const headers = getDefaultHeaders(token);
    const response = await axiosInstance().get(url, withHeaders(headers));
    return response.data;
};

export const useDictionaryDetails = (
    props: any
): UseQueryResult<Dictionary, Error> => {
    const { getToken } = useAuth();
    const { dictionaryId, onLoadSuccess, onLoadError, enabled } = props;

    const url = `${dictionaryBaseUrl}/${dictionaryId}`;
    return useQuery(
        ['dictionary', dictionaryId],
        async () => fetchDictionary(url, getToken()),
        {
            ...fetchDictionary,
            onSuccess: onLoadSuccess,
            onError: onLoadError,
            enabled: enabled,
        }
    );
};
